import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-is-department',
  templateUrl: './home-is-department.component.html',
  styleUrls: ['./home-is-department.component.css']
})
export class HomeIsDepartmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home/home-is-department/home-is-department.component.ts